import React, { Component } from 'react';
import './Footer.css'

class Footer extends Component {
    
    render(){
        return(
            <footer>
                <p>Made with ❤ by <a href="https://github.com/seyon123" target="_blank" rel="noopener noreferrer">Seyon Rajagopal</a></p>
            </footer>
        );
    }
}

export default Footer;